export const SECTIONS_RESET_STATE = 'SECTIONS_RESET_STATE';
export const SECTIONS_CURRENT_ITEM = 'SECTIONS_CURRENT_ITEM';

export const SECTIONS_REQUEST_LOADING = 'SECTIONS_REQUEST_LOADING';
export const SECTIONS_REQUEST_SUCCESS = 'SECTIONS_REQUEST_SUCCESS';
export const SECTIONS_REQUEST_FAILED = 'SECTIONS_REQUEST_FAILED';

export const SECTIONS_CURRENT_ACTION = 'SECTIONS_CURRENT_ACTION';
export const SECTIONS_RESET_ACTION = 'SECTIONS_RESET_ACTION';